/*
 * @Author: haifeng_xie haifeng_xie@kingdee.com
 * @Date: 2023-09-12 10:52:02
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-08 15:05:24
 * @FilePath: \code\src\store\mutations.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
const mutation = {
  set_demo(state, demo) {
    state.demo = demo;
  },
  set_uuid(state, id = "default") {
    state.uuid = id;
  },
  // 主题色
  set_theme(state, color = "#5582f3") {
    state.themeColor = color;
  },
  setWidth(state, width) {
    state.width = width;
  },
  setHeight(state, height) {
    state.height = height;
  },
  // 控件初始化·数据加载态
  set_dataLoadingStatus(state, status = false) {
    state.dataLoadingStatus = status;
  },
  // 设置多语言集合
  set_lang(state, obj = {}) {
    state.langMap = obj;
  },
  init(state, res) {
    if(res.configMap.stayInPlace !== true){ 
      state.initTimeStamp = state.uuid + "-T-" + Date.now(); // 重置回顶
    }

    state.data = res;
    Vue.set(state, "expandMap", {});
    if(!(res.headers instanceof Array)){
      Vue.set(state.data, "headers", []);
    }
    if(!(res.selectedArr instanceof Array)){
      Vue.set(state.data, "selectedArr", []);
    }
    console.log("初始化数据", res);
  },
  set_list(state, arr = []) {    
    Vue.set(state, "expandMap", {});
    Vue.set(state.data, "list", arr);
  },
  set_headers(state, arr = []) {    
    Vue.set(state.data, "headers", arr);
  },
  set_expandMap(state, id) {
    const _oldStatus = state.expandMap[id] || false;
    // state.expandMap[id] = !_oldStatus;
    Vue.set(state.expandMap, id, (!_oldStatus))
    console.log("折叠字典: ", state.expandMap);
  },
  set_treeWidth(state, width = 250){
    state.data.configMap.treeWidth = width;
  },
  set_selectedArr(state, row) {
    let _oldArr = state.data.selectedArr;
    if(_oldArr.includes(row.id)){
      let _index = _oldArr.indexOf(row.id);
      state.data.selectedArr.splice(_index, 1);
    } else {
      state.data.selectedArr.push(row.id);
    }
    console.log("选中行集合", state.data.selectedArr);
  },
  set_detailId(state, id = ""){
    if(state.detailId != id){
      state.detailId = id;
    }
  },
  add_row(state, obj = {
    index: -1,
    item: [{}],
    detailId: "",
  }){
    console.log("局部更新·增加行", obj);
    const {index, item, detailId} = obj;
    if(index >= 0){
      state.detailId = detailId;      
      state.data.list.splice(index, 0, ...item);
    }
  },
  delete_row(state, obj = {
    index: -1,
    item: {},
  }){
    console.log("局部更新·删除行", obj);
    const {index} = obj;
    if(index >= 0){
      state.data.list.splice(index, 1);
    }
  },
  update_row(state, obj = {
    index: -1,
    item: {},
  }){
    console.log("局部更新·修改行", obj);
    const {index, item} = obj;
    if(index >= 0){
      state.data.list.splice(index, 1, item);
    }
  },
  /* 
    通用局部更新
    {
      detailId: "",
      rows: [
        {
          start, 
          deleteLen, 
          items
        }
      ]
    }
  */
  update_rows(
    state, 
    obj = {
      detailId: "",
      rows: []
    }
  ) {
    const {detailId, rows} = obj;
    if(detailId !== ""){
      state.detailId = detailId;
    }
    for (let row of rows) {
      const {start, deleteLen, items} = row;
      let arg = [start, deleteLen];
      if(items && items.length > 0){ arg = [...arg, ...items]; }
      console.log("通用局部更新", arg);
      state.data.list.splice(...arg);
    }
  }

};
export default mutation;
